import { render, staticRenderFns } from "./verPageIndex.vue?vue&type=template&id=48f964e2&scoped=true"
import script from "./verPageIndex.vue?vue&type=script&lang=js"
export * from "./verPageIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f964e2",
  null
  
)

export default component.exports